import { useContext } from "react";
import ordinal from "ordinal";
import formatUSD from "../../../utilities/formatUSD";
import { GraphicalViewerContext } from "../../../contexts/GraphicalViewerContext";

export const PageHeader = () => {
    const { completionIndex, completionsData, completionColors } = useContext(
        GraphicalViewerContext
    );
    const { settings } = useContext(GraphicalViewerContext);
    const textHeadingSize = settings.textHeadingSize || 36;
    const curCompletion = completionsData[completionIndex];
    const color =
        completionColors.length > completionIndex
            ? completionColors[completionIndex]
            : "#6b7280";
    return (
        <div
            id="gv-header"
            className="flex items-center justify-between shadow-md border-4"
            style={{ borderColor: color }}
        >
            <div
                className={`flex justify-center items-center w-36 h-24 text-4xl font-extrabold text-white
                `}
                style={{ backgroundColor: color }}
            >
                <div>{ordinal(completionIndex + 1)}</div>
            </div>
            <div>
                <div className="flex items-center justify-end gap-6 mr-12 font-bold">
                    <div
                        style={{
                            fontSize: textHeadingSize,
                            lineHeight: 1,
                        }}
                    >
                        {formatUSD(curCompletion?.completion_sale_price || 0)}
                    </div>
                    <div className="text-xl text-brand-gray-600">TOTAL</div>
                </div>
                {/* {settings.showPricePerAcre && (
                    <div className="flex items-center justify-end gap-6 mt-1 mr-12 font-bold">
                        <div className="text-2xl">
                            {formatUSD(
                                Math.round(
                                    (curCompletion?.completion_sale_price ||
                                        0) / currentTotalAcres
                                )
                            ) + `/ac`}
                        </div>
                        <div className="ml-6 text-xl text-brand-gray-600">
                            PPA
                        </div>
                    </div>
                )} */}
            </div>
        </div>
    );
};
